export default "__VITE_ASSET__e224cd74__"